<script>
    import { fade } from "svelte/transition";
    import { postApi as post } from "../../service/api";
    import CKEditor from "../../components/CKEditor.svelte";

    export let showModal = false;
    export let handleShowHideModal;
    export let modalTitle = "메일 발송";
    export let to = [''];

    // 상수 정의
	const BASE_URL = "/email";

	// 현재 선택된 서버 확인
	let region = "KR";
	let from = "no-reply@dbbeats.com";
	let fromName = "For me buds";
	let subject = "";
	let content = `<!DOCTYPE html>
					<html lang="en">
							<head>
									<meta charset="UTF-8" />
									<meta name="viewport" content="width=device-width, initial-scale=1.0" />
									<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
									<title>
											[For me buds] Notice on Collection and Use of Personal Information
									</title>
									<style>
											@media (prefers-color-scheme: dark) {
													body {
															background-color: #121212;
															color: #e0e0e0;
													}
													table {
															background-color: #1e1e1e;
															box-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
													}
													.header {
															background-color: #2e7d32;
													}
													.content {
															color: #d0d0d0;
													}
													.content .code {
															background-color: #66bb6a;
															color: #121212;
													}
													.content .expiration {
															color: #aaa;
													}
													.footer {
															background-color: #1e1e1e;
															color: #aaa;
													}
											}
									</style>
							</head>
							<body
									style="
											background-color: #f5f5f5;
											color: #333;
											font-family: Arial, sans-serif;
											line-height: 1.5;
											margin: 0;
											padding: 0;
									"
									bgcolor="#f5f5f5"
							>
									<table
											style="
													background-color: #fff;
													border-radius: 8px;
													border-spacing: 0;
													box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
													margin: 20px auto;
													max-width: 600px;
													overflow: hidden;
													width: 100%;
											"
											bgcolor="#ffffff"
											width="100%"
									>
											<tr>
													<td
															class="header"
															style="
																	background-color: #30374c;
																	color: #fff;
																	font-size: 18px;
																	font-weight: bold;
																	padding: 20px 35px;
																	text-align: left;
															"
															bgcolor="#30374c"
															align="left"
													>
															[For me buds] <br />Notice on Collection and Use of Personal
															Information
													</td>
											</tr>
											<tr>
													<td
															class="content"
															style="color: #505050; font-size: 16px; padding: 35px 25px"
													>
															<p>
																	Hello from <strong>dbbeats</strong><br /><br />
																	This is a summary of the key points regarding the
																	collection and use of your personal information as
																	agreed during sign-up.<br /><br />
																	■ Information Collected<br />
																	Email, birth year, gender, height and weight, sleep and
																	lifestyle habits, app usage data, etc.<br />
																	■ Purpose of Use<br />
																	Account management, personalized services, sleep pattern
																	analysis, service improvement, and enhanced security
															</p>

															<a
																	href="https://sleepwave.oopy.io/formebuds/privacy-policy/common/en"
																	target="_blank"
																	style="display: inline-block; margin-top: 16px"
																	>View Full Privacy Policy</a
															><br /><br />

															<p>
																	Thank you,<br />
																	dbbeats Team
															</p>
													</td>
											</tr>
											<tr>
													<td
															class="footer"
															style="
																	background-color: #f9f9f9;
																	color: #888;
																	font-size: 12px;
																	line-height: 1.4;
																	padding: 20px;
																	text-align: center;
															"
															bgcolor="#f9f9f9"
															align="center"
													>
															This is an automated email - please do not reply.<br />
															For inquiries, please contact
															<a
																	href="mailto:cs@dbbeats.com"
																	style="color: inherit; text-decoration: underline"
																	>cs@dbbeats.com</a
															>
													</td>
											</tr>
									</table>
							</body>
					</html>`;
    let isSending = false;
	// 에디터 관련
	let editorInstance = null;

    // 리전 체크
	$: {
		const selectedServer = localStorage.getItem("selectedServer") || "";
		switch (selectedServer) {
			case "dev-api-backstage.blaupunkt-solum.cn":
			case "api-backstage.blaupunkt-solum.cn":
				region = "CN"
				from = "no-reply@mail.blaupunkt-solum.cn"
                fromName = "Blaupunkt"
				break;
			case "us-api-backstage.sleepwave.ai":
				region = "US"
				break;
			default:
				region = "KR"
		}
	}

	const handleEditorReady = (event) => {
		// 에디터 인스턴스 저장
		editorInstance = event.detail.editor;
	};

	const handleEditorChange = (event) => {
		content = event.detail.data;
	};

	const validateItem = () => {
        if (!from) {
			alert("발신 이메일을 입력하세요");
			return false;
		}
        for (let i = 0; i < to.length; i++) {
            if (!to[i]) {
                alert("수신 이메일을 입력하세요");
                return false;
            }
        }
        if (!fromName && !confirm("발신자명을 작성하지 않았습니다. 이대로 전송하시겠습니까?")) return false;
        if (!subject && !confirm("제목을 작성하지 않았습니다. 이대로 전송하시겠습니까?")) return false;
		return true;
	};

	const addReceiver = () => {
		to = [...to, ''];
	}

	const updateReceiver = (i, v) => {
		to[i] = v;
		to = [...to]; // 배열 변경 감지 위해 새 배열로 할당
	}

  function removeReceiver(i) {
    to = to.filter((_, idx) => idx !== i);
  }

	const handleSend = async () => {
		if (!validateItem()) return;

        isSending = true;
		const payload = {
			region: region,
			subject: subject,
			content: content,
			from: from,
			fromName: fromName,
			to: to,
		};

		try {
			const response = await post(BASE_URL, payload);
			if (response.data.isSuccess) {
				alert("성공적으로 메일을 발송하였습니다.")
			} else {
				alert("메일 발송 중 오류가 발생했습니다.")
			}
		} catch (error) {
			console.error("메일 발송 중 오류 발생:", error);
			alert("메일 발송 중 오류가 발생했습니다.");
		}
        isSending = false;
	};
</script>
{#if showModal}
    <div
    class="modal fade {showModal ? 'show' : ''}"
    style="display: block;"
    tabindex="-1"
    aria-modal="true"
    role="dialog"
    transition:fade={{ duration: 200 }}>
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header bg-dark text-white">
                    <h5 class="modal-title d-flex align-items-center" style="color: white !important;">{@html modalTitle}</h5>
                    <button type="button" class="btn-close btn-close-white" on:click={handleShowHideModal}></button>
                </div>
                <div class="modal-body" style="height: calc(90vh - 120px);">
                    <div class="row h-100">
                        <!-- 좌측: 메일 내용 입력 -->
                        <div class="col-md-7">
                            <div class="mb-1">
                                <h6 class="border-bottom pb-2 mb-3 d-flex align-items-center bg-light p-2 rounded">
                                    <i class="bx bx-envelope me-2"></i>
                                    메일 내용 작성
                                </h6>
                                <div style="padding: 0px; max-height: calc(90vh - 200px); overflow-y: auto;">
                                    <div class="mb-2">
                                        <label for="subjectKo" class="form-label">제목</label>
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            id="subject"
                                            bind:value={subject}
                                            placeholder="제목을 입력하세요"
                                        />
                                    </div>
                                    <div class="mb-2">
                                        <label for="editor" class="form-label">메일 본문</label>
                                        <CKEditor
                                            bind:value={content}
                                            config={{
                                                placeholder: "내용을 입력하세요...",
                                                maxHeight: "calc(90vh - 390px)",
                                            }}
                                            on:ready={(event) => handleEditorReady(event)}
                                            on:change={(event) => handleEditorChange(event)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 우측: 발신/수신 정보 -->
                        <div class="col-md-5 d-flex flex-column h-100">
                            <!-- 설정 정보 -->
                            <div class="mb-4 flex-shrink-0">
                                <h6 class="border-bottom pb-2 mb-3 d-flex align-items-center bg-light p-2 rounded">
                                    <i class="bx bx-send me-2"></i>
                                    발신자 정보
                                </h6>
                                <div class="row mb-3">
                                    <label for="from-email" class="form-label">발신 이메일</label>
                                    <div class="d-flex align-items-center gap-2" id="from-email">
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder="발송 이메일을 입력하세요"
                                            style="width: 200px;"
                                            bind:value={from}
                                        />
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <label for="sender-input" class="form-label">발신자명</label>
                                    <div class="d-flex align-items-center gap-2" id="sender-input">
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder="발신자명을 입력하세요"
                                            style="width: 200px;"
                                            bind:value={fromName}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4 flex-shrink-0">
                                <h6 class="border-bottom pb-2 mb-3 d-flex align-items-center bg-light p-2 rounded">
                                    <i class="bx bx-package me-2"></i>
                                    수신자 정보
                                </h6>
                                <div class="row mb-3" style="padding: 0px; max-height: calc(90vh - 420px); overflow-y: auto;">
                                    <label for="receiver-input" class="form-label">수신 이메일</label>
                                    <div id="sender-input">
                                        {#each to as receiver, idx}
                                            <div class="d-flex align-items-center gap-2 mb-1">
                                                <input
                                                    type="text"
                                                    class="form-control form-control-sm"
                                                    placeholder="수신 이메일을 입력하세요"
                                                    style="width: 200px;"
                                                    bind:value={to[idx]}
                                                    on:input={(e) => updateReceiver(idx, e.target.value)}
                                                />
                                                {#if idx == 0}
                                                    <button class="btn btn-secondary btn-sm" on:click={addReceiver} type="button">
                                                        <i class="bx bx-plus"></i>
                                                    </button>
                                                {:else}
                                                    <button class="btn btn-secondary btn-sm" on:click={()=>removeReceiver(idx)} type="button">
                                                        <i class="bx bx-minus"></i>
                                                    </button>
                                                {/if}
                                            </div>
                                        {/each}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-center">
                    <button type="button" class="btn btn-sm btn-outline-primary" on:click={handleShowHideModal} disabled={isSending}>취소</button>
                    <button type="button" class="btn btn-sm btn-primary" on:click={handleSend} disabled={isSending}>
                        {#if isSending}
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            처리 중...
                        {:else}
                            발송
                        {/if}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade {showModal ? 'show' : ''}" transition:fade={{ duration: 200 }}></div>
{/if}
